import { Component } from 'react';
import * as styles from './styles';
import EmptyBlock from './EmptyBlock';
import InvoiceInfo from './InvoiceInfo';

class Invoice extends Component {
  constructor() {
    super();
    this.deleteInvoice = this.deleteInvoice.bind(this);
  }

  componentDidMount() {
    let { appointmentId, actions } = this.props;
    actions.loadInvoice(appointmentId);
  }

  deleteInvoice() {
    let {
      actions,
      appointment: { invoice },
      appointmentId
    } = this.props;
    actions.deleteInvoiceById(invoice, appointmentId);
  }

  render() {
    const {
      i18n,
      appointmentId,
      appointment: { invoice, timeline },
      actions,
      openPaymentModal
    } = this.props;

    return (
      <styles.InvoiceBlock>
        {invoice.invoiceItems ? (
          <InvoiceInfo
            invoice={invoice}
            i18n={i18n}
            deleteInvoice={this.deleteInvoice}
            confirmPayment={actions.confirmPayment}
            openPaymentModal={openPaymentModal}
            appointmentId={appointmentId}
          />
        ) : (
          <EmptyBlock
            i18n={i18n}
            appointmentId={appointmentId}
            currentStatus={timeline.currentStatus}
          />
        )}
      </styles.InvoiceBlock>
    );
  }
}

export default Invoice;
